import Lookup from 'src/componentes/select-async';
import OrganizacaoList from 'src/paginas/organizacao';
import OrganizacaoEdit from 'src/paginas/organizacao/edit';

const OrganizacaoLookup = ({ exibirInativos, data, ...rest }) => {
  return (
    <Lookup
      url="/OrganizacaoLookup"
      valueKey="id"
      labelKey="nome"
      showSearch
      clearable={true}
      hierarchy={true}
      editComponent={OrganizacaoEdit}
      searchComponent={OrganizacaoList}
      {...rest}
      data={{
        ...data,
        viewListSearch: !exibirInativos,
        exibirInativos: exibirInativos,
      }}
    />
  );
};

export default OrganizacaoLookup;
